import styled from "styled-components";

export const StyledSvg = styled.svg`
  position: relative;
`;
